import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const DISCLAIMER_SHORT = 'Disclaimer: The Site does not offer professional or definitively accurate...';
const DISCLAIMER_FULL = 'Disclaimer: The Site does not offer professional or definitively accurate personality assessments. Results are for informational purposes only. The content provided should not be considered as a substitute for professional psychological advice, diagnosis, or treatment. Always seek the guidance of a qualified professional with any questions you may have regarding your mental health or well-being.';

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();
    const [expanded, setExpanded] = useState(false);

    return (
        <footer className="footer">
            <div className="footer__main">
                <div className="footer__container">
                    <div className="footer__brand">
                        <Link to="/" className="footer__logo">
                            <img 
                                src="/images/logo-full.png" 
                                alt="DoYourStep" 
                                className="footer__logo-img"
                            />
                        </Link>
                        <span className="footer__tagline">Created by experts</span>
                    </div>

                    <div className="footer__divider" />

                    <div className="footer__content">
                        <div className="footer__links">
                            <div className="footer__column">
                                <Link to="/" className="footer__link">Home</Link>
                                <Link to="/about" className="footer__link">About Us</Link>
                                <Link to="/pricing" className="footer__link">Pricing</Link>
                                <Link to="/faqs" className="footer__link">FAQs</Link>
                            </div>
                            <div className="footer__column">
                                <Link to="/contact" className="footer__link">Contact Us</Link>
                                <Link to="/login" className="footer__link">Sign in</Link>
                            </div>
                            <div className="footer__column">
                                <Link to="/privacy" className="footer__link">Privacy Policy</Link>
                                <Link to="/terms" className="footer__link">Terms of Use</Link>

                            </div>
                        </div>

                        <div className="footer__disclaimer">
                            <p>
                                {expanded ? DISCLAIMER_FULL : DISCLAIMER_SHORT}
                                {' '}
                                <button
                                    type="button"
                                    className="footer__read-more"
                                    onClick={() => setExpanded(!expanded)}
                                >
                                    {expanded ? 'show less' : 'read more'}
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer__bottom">
                <p className="footer__copyright">
                    © {currentYear} DoYourStep. All rights reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
